import { SearchSeriesEntity } from '@generated-client/backend';
import { Path } from '@trwl/shared/lib/router';
import { FILTERS, SEARCH, SERIES_SUGGESTIONS } from '@trwl/store';
import { serializeFilterToQuery } from '@trwl/store/filter/serializer';
import { useUnit } from 'effector-react';
import { useRouter } from 'next/navigation';
import React, { useCallback } from 'react';

import { SearchResultRow } from './SearchResultRow';

export const SeriesSuggestion = ({
  onItemClick,
}: {
  onItemClick?: (path: string) => void;
}) => {
  const clearFilter = useUnit(FILTERS.clearFilter);
  const [setSeriesIds, setBrandIds] = useUnit([
    FILTERS.setSeriesIds,
    FILTERS.setBrandIds,
  ]);
  const searchQuery = useUnit(SEARCH.$search);
  const series = useUnit(SERIES_SUGGESTIONS.$seriesSuggestions);
  const router = useRouter();

  const handleClick = useCallback(
    (series: SearchSeriesEntity) => {
      const path = `${Path.CATALOG}?filter=${serializeFilterToQuery({
        brandIds: series.brandId ? [series.brandId] : undefined,
        seriesIds: [series.id],
      })}`;
      onItemClick?.(path);
      clearFilter();
      setSeriesIds([series.id]);
      if (series.brandId) setBrandIds([series.brandId]);
      router.push(path);
    },
    [clearFilter, onItemClick, router, setBrandIds, setSeriesIds],
  );

  if (searchQuery.trim().split(' ').length > 3) return null;
  if (!series.length) return null;

  return (
    <div className={'w-full flex flex-col items-start gap-2'}>
      <div>Коллекции</div>
      {series.map((item) => (
        <SearchResultRow
          key={'series_' + item.id}
          onClick={() => handleClick(item)}
        >
          {item.name}
        </SearchResultRow>
      ))}
    </div>
  );
};
